const siteUrlLanguageToHrefLang = code => {
  // This HK is a place not a language so we need to fix it here.
  // The remainder are languages, though often the site URLs are
  // not as precise as the Crowdin codes.
  if (code === "hk") {
    return "zh-HK";
  }
  return code;
};

module.exports = {
  siteUrlLanguageToHrefLang
};
